import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { RaisedButton } from 'material-ui';
import LocationIcon from '../../icons/LocationIcon';
import {BODY_TEXT_COLOR} from '../../config/colors';
import './style.css';

const styles = {
  editIcon: { width: '30px', height: '30px' },
  deliveryIcon: {
    margin: '0 10px'
  },
  dispensaryName: { fontWeight: 700 },
  editAddressStyle: { position: 'absolute', cursor: 'pointer', right: '18px', top: '0' },
  textArea: { display: 'block' },
  deliveryNotes: { fontWeight: '600', marginBottom: '10px', color: '#616161' },
  contMargin: { marginLeft: '10px' },
};

class CheckoutAddress extends Component {
  constructor(props) {
    super(props);
    this.state = {
      notes: props.note
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.note === '' && nextProps.note !== '') {
      this.setState({ note: nextProps.note });
    }
  }

  getAddress = () => {
    const { isDeliveryAddressIncorrect } = this.props;

    if (!this.props.currentAddress) {
      return null;
    }
    if (this.props.isDelivery) {
      const { street, city, zip, state, apt } = this.props.currentAddress;
      return (
        <div className="treez-checkout-items-details">
          {/*<div><CarIcon color="#616161" style={styles.deliveryIcon}/></div>*/}
          <div className="treez-checkout-items-details-left" style={styles.contMargin}>
            <div style={styles.deliveryNotes}>Deliver To:</div>
            <div>{this.props.fullName}</div>
            <div>{street},</div>
            <div>{city}, {state} {zip}</div>
            {apt && <div>Apt #{apt}</div>}

            {isDeliveryAddressIncorrect &&
              <div className="checkout-error-message">
                Sorry we don't deliver to this address.
              </div>
            }

            <RaisedButton
              backgroundColor={this.props.secondaryColor}
              labelStyle={{ fontWeight: 700 }}
              labelColor="#FFF"
              label="Change"
              style={styles.editAddressStyle}
              buttonStyle={{}}
              onClick={() => {this.props.openShippingForm(this.props.getSummary)}}
            />
          </div>
        </div>
      )
    } else {
      const { street, city, zip, state } = this.props.currentAddress;
      return (
        <div className="treez-checkout-items-details">
          <div style={styles.deliveryIcon}>
            <LocationIcon color={BODY_TEXT_COLOR}/>
          </div>
          <div className="treez-checkout-items-details-left" style={styles.contMargin}>
            <div style={styles.deliveryNotes}>Pickup At:</div>
            <div style={styles.dispensaryName}>{this.props.currentAddress.dispensaryName}</div>
            <div>{street},</div>
            <div>{city}, {state} {zip}</div>

            <RaisedButton
              backgroundColor={this.props.secondaryColor}
              labelStyle={{ fontWeight: 700 }}
              labelColor="#FFF"
              label="Change"
              style={styles.editAddressStyle}
              buttonStyle={{}}
              onClick={() => {this.props.openShippingForm(this.props.getSummary)}}
            />
          </div>
        </div>
      )
    }
  }

  handleNotes = (e) => {
    this.setState({ notes: e.target.value });
  }

  renderNotes = () => {
    const {
      isDelivery,
      notesAllowed,
    } = this.props;

    if (!isDelivery || !notesAllowed) return null;

    return (
      <div className="treez-checkout-items-details" style={styles.textArea}>
        <div style={styles.contMargin}>
          <div style={styles.deliveryNotes}>Delivery Notes</div>
          <textarea
            rows={3}
            value={this.state.notes}
            onChange={this.handleNotes}
            placeholder="Delivery note"
            className="checkout-notes-input"
          />
        </div>
      </div>
    );
  }

  render() {
    return (
      <div style={{ margin: '0 10px' }}>
        {this.getAddress()}
        {this.renderNotes()}
      </div>
    );
  }
}

CheckoutAddress.defaultProps = {
  note: '',
  fullName: ''
};

CheckoutAddress.propTypes = {
  isDelivery: PropTypes.bool,
  openShippingForm: PropTypes.func.isRequired,
  getSummary: PropTypes.func.isRequired,
  note: PropTypes.string,
  fullName: PropTypes.string,
  notesAllowed: PropTypes.bool.isRequired,
  secondaryColor: PropTypes.string.isRequired
};

export default CheckoutAddress;



// WEBPACK FOOTER //
// ./src/components/CheckoutAddress/CheckoutAddress.jsx